import React from "react";
import PropTypes from "prop-types";
// Material Imports
import { styled } from "@mui/material/styles";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
const LeftNavIconButton = styled(IconButton)(({
  theme,
  selected
}) => ({
  "& .MuiSvgIcon-root": {
    width: 28,
    height: 28,
    padding: 16,
    margin: "10px auto",
    color: selected ? theme.palette.primary.main : theme.palette.grey[3],
    opacity: selected ? 1 : 0.6,
    "&:hover": {
      color: selected ? theme.palette.primary.light : theme.palette.grey[2]
    }
  }
}));
const NavigtaionItem = ({
  onClickHandle,
  link,
  text,
  icon,
  selected,
  id
}) => {
  const handleClick = event => {
    onClickHandle(link, event);
  };
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(LeftNavIconButton, {
    icon: icon,
    label: text,
    id: `navigationItemButton${id}`,
    onClick: handleClick,
    selected: selected,
    size: "large",
    tooltipPlacememnt: "right",
    disableRipple: true
  }));
};
export default NavigtaionItem;
NavigtaionItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  link: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onClickHandle: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};